export default "__VITE_ASSET__CUb$2$ZS__"